module.exports = "/dist/assets/images/sort-icon.svg";